export const scrollToTop = () => {
  document.querySelector(".main-container")?.scrollTo(0, 0);
  document.querySelector(".main-container")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
